var module = angular.module('octopusApp.library');

module.controller('PackageRepositoryRetentionController', function($scope, $location, busy, pageTitle, octopusRepository, octoDialog, unsavedChanges) {
  var isLoading = $scope.isLoading = busy.create();
  var isSaving = $scope.isSaving = busy.create();

  isLoading.promise(octopusRepository.PackageRepository.getConfiguration().then(function (repositoryConfiguration) {
    $scope.repositoryConfiguration = repositoryConfiguration;
    $scope.view = { KeepForever: !repositoryConfiguration.DeleteUnreleasedPackagesAfterDays };
  }));

  $scope.save = function() {
    if ($scope.view.KeepForever){
      $scope.repositoryConfiguration.DeleteUnreleasedPackagesAfterDays = null;
    } else {
      $scope.repositoryConfiguration.DeleteUnreleasedPackagesAfterDays = $scope.repositoryConfiguration.DeleteUnreleasedPackagesAfterDays || 0;
    }
    isSaving.promise(octopusRepository.PackageRepository.updateConfiguration($scope.repositoryConfiguration).then(function(){
      unsavedChanges.saved();
      $location.path('/library/packages');
    }));
  };

});




//////////////////
// WEBPACK FOOTER
// ./app/areas/library/packages/controllers/package_repository_retention_controller.js
// module id = 455
// module chunks = 1